import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor( private readonly alertController: AlertController ) { }


  async presentErrorAlert ( message: string = "Oops! An error occured, if this problem persists please contact our support." ) {
    const alert = await this.alertController.create({
      message: message,
      buttons: ['OK']
     });
     await alert.present();     
  }

  showDefaultError () {
   return this.alertController.create({
      message: `Oops! An error occured, if this problem persists please contact our <a href="http://support.salonmonster.com">support</a>.`,
      buttons: ['OK']
     });
  }


}
